var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinvueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 102 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill-rule: evenodd;\n      }\n\n      .st0, .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 42.6,
    y1: 15.2,
    x2: 70.4,
    y2: 15.2,
    gradientTransform: "translate(0 29.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#4722d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4f2adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#633ef1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6b46f9"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.1,14.3l7.4,11.9c1.2,1.9,3.9,1.9,5.1,0l14.4-22.3c1-1.5,0-3.5-1.9-3.5s-1.5.4-1.9,1.1l-10.7,16.8c-1,1.6-3.3,1.6-4.3,0l-.4-.6c-.9-1.5,0-3.4,1.8-3.4s1.4-.4,1.8-1h0c1-1.6,0-3.6-1.9-3.6h-7c-2.4,0-3.8,2.6-2.5,4.6h.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.5,27.5c-1.3,0-2.5-.3-3.5-.9s-1.7-1.5-2.3-2.6c-.5-1.1-.8-2.5-.8-4.1v-9.4c0-.2,0-.4.2-.6.2-.2.3-.2.6-.2h3.1c.2,0,.4,0,.6.2s.2.3.2.6v9.2c0,2.7,1.2,4,3.5,4s2-.3,2.7-1,1-1.7,1-3v-9.2c0-.2,0-.4.2-.6.2-.2.4-.2.6-.2h3.1c.2,0,.4,0,.6.2s.2.3.2.6v15.9c0,.2,0,.4-.2.6s-.4.2-.6.2h-2.9c-.2,0-.4,0-.6-.2s-.2-.3-.2-.6v-1.4c-.6.8-1.3,1.4-2.2,1.9-.9.4-2,.6-3.3.6h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.3,27.5c-2.5,0-4.4-.7-5.9-2.1s-2.3-3.5-2.4-6.1v-1.6c0-1.7.5-3.2,1.1-4.4.7-1.2,1.6-2.2,2.8-2.8,1.2-.7,2.7-1,4.3-1s3.3.4,4.6,1.1c1.2.8,2.1,1.8,2.8,3.2.6,1.3,1,2.8,1,4.6v.7c0,.2,0,.4-.2.6s-.4.2-.6.2h-11v.3c0,.8.2,1.5.5,2.1s.7,1.1,1.2,1.5,1.2.6,1.9.6,1.1,0,1.5-.3c.4-.2.8-.4,1-.6.3-.2.5-.4.6-.6.2-.3.4-.4.5-.5,0,0,.3-.1.6-.1h3c.2,0,.4,0,.5.2.2.1.2.3.2.5,0,.4-.2.8-.6,1.3-.3.5-.8,1-1.5,1.5-.6.5-1.5.9-2.4,1.2-1,.3-2.1.5-3.3.5h-.2ZM96.9,16.9h-7.2c0-1,0-1.7.4-2.3s.7-1.2,1.2-1.5c.5-.4,1.2-.5,1.9-.5s1.4.2,1.9.5c.5.4.9.9,1.2,1.5.3.6.4,1.4.4,2.2h.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.2,27.2c-.2,0-.4,0-.6-.2s-.2-.3-.2-.6v-15.9c0-.2,0-.4.2-.6.2-.2.3-.2.6-.2h2.9c.2,0,.4,0,.6.2s.2.3.2.6v1.4c.6-.7,1.3-1.3,2.2-1.8s2-.7,3.4-.7,2.5.3,3.5.9c1,.6,1.8,1.5,2.3,2.6.6,1.1.8,2.5.8,4v9.4c0,.2,0,.4-.2.6,0,.2-.3.2-.6.2h-3.1c-.2,0-.4,0-.6-.2s-.2-.3-.2-.6v-9.2c0-1.3-.3-2.3-.9-3-.6-.7-1.5-1.1-2.7-1.1s-2,.4-2.7,1.1c-.7.7-1,1.7-1,3v9.2c0,.2,0,.4-.2.6s-.3.2-.6.2h-3.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.7,27.2c-.2,0-.4,0-.6-.2s-.2-.3-.2-.6v-15.9c0-.2,0-.4.2-.6.2-.2.3-.2.6-.2h2.9c.2,0,.4,0,.6.2s.2.3.2.6v15.9c0,.2,0,.4-.2.6-.1.2-.3.2-.6.2h-2.9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.6,6.9c-.2,0-.4,0-.6-.2s-.2-.4-.2-.6v-2.5c0-.2,0-.4.2-.6.2-.2.3-.2.6-.2h3.2c.2,0,.4,0,.6.2s.2.3.2.6v2.5c0,.2,0,.4-.2.6s-.3.2-.6.2h-3.2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M.8,27.2c-.2,0-.4,0-.6-.2C0,26.8,0,26.7,0,26.4V4.5C0,4.3,0,4.1.2,3.9c.2-.2.3-.2.6-.2h14.6c.2,0,.4,0,.6.2.2.2.2.4.2.6v2.5c0,.2,0,.4-.2.6-.1.2-.3.2-.6.2H4.7v6.2h10c.2,0,.4,0,.6.2.2.1.2.3.2.6v2.5c0,.2,0,.4-.2.6-.1.2-.3.2-.6.2H4.7v8.2c0,.2,0,.4-.2.6,0,.2-.3.2-.6.2H.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinvueLogo);
export default __webpack_public_path__ + "static/media/finvue_logo.a3f993d90951c054ceafdc9bda302838.svg";
export { ForwardRef as ReactComponent };